<template>
  <div id="resume">
    <div class="infobar"><div class="subbar"><h1>RESUME</h1></div></div>
    <div class="pageContent">
      <div class="mainBlock">
        <pdf
            style="width: 90%"
            src="/assets/redactedakoshy-resume.pdf"></pdf>
      </div>
      <div class="sidebar">
        <a a href="/assets/redactedakoshy-resume.pdf" download><i class="fas fa-download"></i></a>

      </div>
    </div>
    <!--  <div class="scroll"><table><tr><th>Education</th></tr></table>-->
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
name: "resume",
  components: {
    pdf
  }
}
</script>

<style scoped>
table{
  margin-left:30px;
  margin-top: 40px;
}

.resume{
  flex-grow:1;
  padding-left:50px;
  align-items: stretch;
  height:100vh;
}

table th{
  font-family: 'lemonmilk';
  font-display: swap;
  font-size: 36px;
  vertical-align: top;
  text-align: right;
  color: var(--second);}


.subbar
{
  display:flex;
  width:100%;
  justify-content: space-between;
}

.sidebar {
  flex: 1;
  max-height: 6em;
  padding-left: 15px;
  border-left: solid 3px var(--second);
  font-size: 24px;
  position: -webkit-sticky;
  position: sticky;

  margin-left: 1em;
  top: 11.5rem;
}

.sidebar .share-network-facebook{
  display:block;
  width:25px;
}
.sidebar i{
  color:var(--second);
  margin-bottom:8px;
}

.sidebar i:hover{
  color:var(--primarylight);
  cursor:pointer;
}


.mainBlock{flex: 0 1 940px;
  display:flex;
  justify-content: center;
  max-width:940px;
  margin-bottom:10em;}


.image img{
  border: .5em solid var(--secondlight);
  width:100%;
  margin:-1em;
}

#resume{
  display:flex;
  flex-grow:1;
  color:black;
  font-family: 'montserrat';
  overflow-y:scroll;
  flex-direction:column;
  align-items: stretch;
  height:100vh;
  font-size:14px;
}

.infobar{

  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background: var(--secondlight);
  padding: 0 50px;
  flex: 0 0 150px;
  display:flex;
  flex-direction: column;
  justify-content: center;
  z-index: 10;
}

.infobar h1{
  font-family: 'lemonmilk';
  font-display: swap;
  font-size: 2em;
  vertical-align: top;
  letter-spacing:.1em;
  text-align: left;
  margin:0.25em 0em;
  color: var(--second);
}

.pageContent h2{
  margin-bottom:5px;
  margin-top:0;
  font-family: lemonmilk;
  font-display: swap;
  font-size:1rem;
  letter-spacing: .2em;
}

.pageContent{
  display:flex;
  flex-direction:row;
  flex:1;

  padding:0px 50px;
  margin-top:30px;
}


#resume::-webkit-scrollbar-track {
  background: var(--second);
  border: 4px solid var(--darkbg)!important;
  border-radius: 10px;
}

#resume::-webkit-scrollbar-thumb {
  background: var(--darkbg);
  border: 4px solid var(--second);
}

-webkit-scrollbar:hover{
  cursor:pointer;
}

#resume::-webkit-scrollbar-thumb:hover {
  background: var(--second);
  border: 4px solid var(--seconddark);
}

#resume::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background: var(--second);}

</style>